import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { formatImageWebpAuto } from '@ifeng/public_method';
import { getFengcxData } from '../../../../../services/api';
import { oneChangeTwoDimensional, isIE78 } from '../../../../../utils/utils';

class FengcxBox extends React.PureComponent {
    state = {
        data: {},
        current: 0,
    };

    async componentDidMount() {
        let data = await getFengcxData();

        data = {
            ...data,
            list: oneChangeTwoDimensional([...data.list], 4),
        };

        this.setState({
            data: { ...data },
        });
    }

    handleListChange = () => {
        const {
            data: { list },
        } = this.state;
        let { current } = this.state;

        current += 1;

        if (current < list.length) {
            this.setState({
                current,
            });
        } else {
            this.setState({
                current: 0,
            });
        }
    };

    render() {
        const {
            data: { list, more },
            current,
        } = this.state;

        return (
            <div className={styles.fengcx_box}>
                <div className={styles.fengcx_title}>企业舆情跟踪</div>
                <div className={styles.list}>
                    {list &&
                        list[current] &&
                        list[current].map(item => (
                            <div key={item.company_id} className={styles.item}>
                                <a href={item.company_url} target="_blank" title={item.company_name}>
                                    <img src={formatImageWebpAuto(item.company_logo, 74, 74)} alt={item.company_name} />
                                </a>
                                <a className={styles.dy} href={item.sentiment_url} target="_blank">
                                    <span>+订阅</span>
                                </a>
                            </div>
                        ))}
                </div>
                <div className={styles.more_box}>
                    <a href={more} target="_blank">
                        更多企业舆论追踪
                    </a>
                    <a className={isIE78() ? styles.change_box : styles.change_box_2x} onClick={this.handleListChange}>
                        <span />
                        <span>换一批</span>
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(FengcxBox);
